import { NavLink } from 'react-router-dom'

export default function Corte() {

    const navCorte = [
        {
            link : '/corte/resumen',
            icon : "bi bi-table",
            title : "Resumen",
            description : "Total de movimientos en la última quincena",
        },{
            link : "/corte/busquedas-realizadas",
            icon : "bi bi-binoculars",
            title : "Búsquedas",
            description : "Búsquedas de la última quincena",
        },{
            link : "/corte/otros-conceptos",
            icon : "bi bi-journal-plus",
            title : "Otros conceptos",
            description : "Ingresos y gastos",
        },{
            link : "/corte/corte-de-caja",
            icon : "bi bi-currency-dollar",
            title : "Corte de caja",
            description : "Dinero en efectivo",
        },{
            link : "/corte/traslados",
            icon : "bi bi-wallet2",
            title : "Traslados",
            description : "Enviar dinero a otra caja",
        },
    ]

    return (
        <>
            <style type='text/css'>
                {`
                    .aside-hover:hover{
                        box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
                        border-radius: 0.475rem;
                    }
                `}
            </style>
            <div className="pt-3">
                <h1 className="text-gray-800 fw-bold fs-1">
                    Corte
                </h1>
                <div className="pt-4">
                    {
                        navCorte && navCorte.map((item) => {
                            return(
                                <NavLink
                                    key={item.link}
                                    to={item.link}
                                    className={({ isActive }) => (isActive ? "bg-light-primary " : "") + "d-flex align-items-center px-5 py-4 bg-hover-light-primary"}
                                >
                                    <div className="symbol symbol-50px me-5">
                                        <span className="symbol-label bg-gray-100">
                                            <i className={item.icon + " fs-1 text-primary"}></i>
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column flex-grow-1">
                                        <h5 className="custom-list-title fw-semibold text-gray-800 mb-1">
                                            {item.title}
                                        </h5>
                                        <span className="text-gray-500 fw-bold">
                                            {item.description}
                                        </span>
                                    </div>
                                </NavLink>
                            );
                        })
                    }
                </div>
            </div>
        </>
    );
}
